import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const ThrophIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.3419 3.24805H7.65528C7.40879 3.24805 7.2008 3.42097 7.1698 3.6655C6.87563 5.98667 5.77658 17.1994 11.9986 17.1994C18.2206 17.1994 17.1216 5.98667 16.8274 3.66551C16.7964 3.42097 16.5884 3.24805 16.3419 3.24805Z"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.84838 5.20299L3.74377 4.78667C3.21536 4.71581 2.72735 5.07268 2.66298 5.60192C2.45153 7.3404 2.2059 11.0415 3.61993 12.8573C5.08349 14.7367 8.43918 15.6801 8.43918 15.6801"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.1536 5.20299L20.2582 4.78667C20.7866 4.71581 21.2746 5.07268 21.339 5.60192C21.5504 7.3404 21.7961 11.0415 20.382 12.8573C18.9185 14.7367 15.5628 15.6801 15.5628 15.6801"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.26367 22.2473C8.26367 22.2473 8.9938 20.6914 12.0835 20.6914C15.1731 20.6914 15.7371 22.2472 15.7371 22.2472"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M11.998 20.4907V17.334" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
